// @ts-check
// Diálogo grande das telas de e-mail (galeria, biblioteca de imagens, prévia, teste, Identidade e envio): cabeçalho
// com título e fechar, corpo com rolagem e rodapé opcional. No celular ocupa a tela inteira (spec/email.md seção 19.4).
import { html } from 'htm/preact';
import { createPortal } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { LightIconButton } from '../../ui/button.js';
import { t } from '../../i18n/index.js';

/**
 * @param {{ title: string, subtitle?: string, onClose: () => void, children?: any, footer?: any, size?: 'medium' | 'large' | 'full',
 *   className?: string, headerActions?: any, testId?: string }} props
 */
export function EmailDialog({ title, subtitle, onClose, children, footer, size = 'medium', className = '', headerActions, testId }) {
  const dialogRef = useRef(/** @type {HTMLDivElement | null} */ (null));
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const previousFocus = /** @type {HTMLElement | null} */ (document.activeElement);
    requestAnimationFrame(() => {
      const dialog = dialogRef.current;
      const first = /** @type {HTMLElement | null} */ (dialog?.querySelector('[autofocus], input, textarea, button:not([data-dialog-close])') ?? null);
      (first ?? dialog)?.focus({ preventScroll: true });
    });
    /** @param {KeyboardEvent} event */
    const handleKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      // um menu aberto dentro do diálogo fecha primeiro
      if (document.querySelector('[data-dropdown-surface]')) return;
      event.stopPropagation();
      closeRef.current();
    };
    document.addEventListener('keydown', handleKeyDown, true);
    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
      previousFocus?.focus?.({ preventScroll: true });
    };
  }, []);

  return createPortal(
    html`<div class="modal-backdrop email-dialog-backdrop" onMouseDown=${(/** @type {MouseEvent} */ event) => event.target === event.currentTarget && onClose()}>
      <div ref=${dialogRef} class=${`email-dialog ${className}`} data-size=${size} role="dialog" aria-modal="true" aria-label=${title} tabindex="-1" data-testid=${testId}>
        <header class="email-dialog-header">
          <div class="email-dialog-titles">
            <h2 class="email-dialog-title">${title}</h2>
            ${subtitle ? html`<p class="email-dialog-subtitle">${subtitle}</p>` : null}
          </div>
          <div class="email-dialog-header-actions">
            ${headerActions ?? null}
            <${LightIconButton} icon="IconX" size="medium" ariaLabel=${t('common.close')} onClick=${onClose} data-dialog-close="true" />
          </div>
        </header>
        <div class="email-dialog-body">${children}</div>
        ${footer ? html`<footer class="email-dialog-footer">${footer}</footer>` : null}
      </div>
    </div>`,
    document.body,
  );
}
